import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import clientRoutes from '../../../components/client/clientRoutes';

const update = createAsyncThunk(
  'thunk/client/update',
  async (arg, thunkAPI) => {
    const response = await apiFetch(clientRoutes.api.generate.update(arg?.id), {
      body: arg?.data,
      method: 'POST',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
